import { useEffect, useState } from 'react';

interface RenderClientSideProps {
  children: React.ReactElement | React.ReactElement[];
  skeleton?: React.ReactElement;
}

const RenderClientSide = ({
  children,
  skeleton,
}: RenderClientSideProps): React.ReactElement | React.ReactElement[] | null => {
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    setShouldRender(true);
  }, []);
  return shouldRender ? children : skeleton ? skeleton : null;
};

export default RenderClientSide;
